import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'dd-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent implements OnInit {

  @Input() phoneNumber = '';
  @Input() showPhoneIcon = true;

  isLexus: boolean=false;
  constructor() { }

  ngOnInit() {
    this.isLexus = document["isLexus"];
  }
}
